/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {
    MESSAGE_DETAILS: 'Message details',
    OK: 'OK'
  },
  ERROR: {
    ERROR: 'Error',
    FETCH_DATA: 'Fetch data',
    NO_ORDER: 'Unable to place order'
  },
  HEADER: {
    DATE: 'Date',
    MESSAGE: 'Message',
    NAME: 'Client Name',
    ORDER_CODE: 'Order code',
    ORDER_DATE: 'Order date',
    ORDER_ID: 'Order',
    ORDER_VALUE: 'Amount',
    PAYMENT_DATE: 'Payment date',
    PAYMENT_STATE: 'Payment state',
    PRICE: 'Price',
    VALUE: 'Amount'
  },
  LABEL: {
    COPIED: 'Copied!',
    EXPORT: 'Export',
    GIVEWAY_DATE: 'Draw date:',
    MONTH: 'Month',
    ORDER_PRIZE_MSG: 'Winning order:',
    PAYED: 'Paid',
    PRIZE: 'Giveaway',
    RAFFLE: 'Giveaway',
    UNPAYED: 'Unpaid',
    UNTIL: 'until',
    YEAR: 'Year'
  },
  SENTENCE: {
    NO_ROWS_ORDER_MESSAGES: 'No messages',
    NO_ROWS_ORDER_MESSAGES_DESCRIPTION: 'No messages from customers (yet).',
    NO_ROWS_ORDERS: 'No orders',
    NO_ROWS_ORDERS_DESCRIPTION: 'No orders (yet).'
  },
  SUCCESS: {
    SUCCESS: 'Success'
  },
  TOOLTIP: {
    DATE: 'Date',
    ORDER_CODE: 'Order code',
    ORDER_ID: 'Order',
    PAYMENT_DATE: 'Payment date',
    PAYMENT_STATE: 'Payment state',
    PRICE: 'Price',
    VALUE: 'Amount'
  }
};
